module.exports = new __parcel__URL__("shop_sold_out_button.25449f9b.png").toString();